module.exports = __webpack_public_path__ + "static/media/check.8d929b40.gif";